import { routedClient } from "react-migration/lib/persistence/apollo";
import CREATE_SITES_DRY_RUN from "../graphql/createSitesDryRun.gql";
import { CreateSitesDryRunResponse } from "../typings";
import type { Site } from "../typings/Site";

type DryRunSiteParams = {
  site: Site;
};

export const dryRunSite = async ({ site }: DryRunSiteParams) => {
  const { data } = await routedClient.mutate<CreateSitesDryRunResponse>({
    mutation: CREATE_SITES_DRY_RUN,
    variables: {
      sites: [site],
      siteMatchType: "EXACT",
    },
  });
  return data?.createSitesDryRun?.[0].saved_site;
};
